import type { FieldErrors, FieldValues } from 'react-hook-form';

const pathSegmentRegex = /[^.[\]]+/g;

export const getFieldErrorMessage = (errors: FieldErrors<FieldValues> | undefined, name?: string): string => {
  if (!errors || !name) {
    return '';
  }

  const segments = name.match(pathSegmentRegex) ?? [];
  const fieldError = segments.reduce<unknown>((current, segment) => {
    if (!current || typeof current !== 'object') {
      return undefined;
    }

    return (current as Record<string, unknown>)[segment];
  }, errors);

  if (!fieldError || typeof fieldError !== 'object') {
    return '';
  }

  const message = (fieldError as { message?: unknown }).message;
  return typeof message === 'string' ? message : '';
};
